import React from "react";
import { Link } from "react-router-dom";
import { Page } from "@/components/Layout";
import { ArrowRight } from "@phosphor-icons/react";

const themes = ["Pathways into psychology", "DClinPsy & DEdPsy demystified", "Research & academia", "Industry & applied roles", "Study abroad strategy", "Building a portfolio"];

export default function CareerWorkshops() {
  return (
    <Page>
      <section className="md-section md-page-hero">
        <div className="md-container">
          <div className="md-label-eyebrow mb-4">Psychology Career Workshops</div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif">Help your students <em>see the map</em></h1>
          <p className="text-base mt-5 max-w-2xl mx-auto">
            Interactive workshops led by practising psychologists and academics, for schools, universities and youth organisations.
          </p>
        </div>
      </section>

      <section className="md-section">
        <div className="md-container text-center">
          <div className="md-label-eyebrow mb-3">Workshop Themes</div>
          <div className="flex flex-wrap gap-2 justify-center">{themes.map((t) => <span key={t} className="md-tag">{t}</span>)}</div>
          <div className="mt-10">
            <Link to="/contact?source=career-workshops-enquire" className="btn-primary" data-testid="career-workshops-enquire">Request a Workshop <ArrowRight size={14} weight="bold" /></Link>
          </div>
        </div>
      </section>
    </Page>
  );
}
